import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from 'src/components/Octopath/layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Menu = makeShortcode("Menu");
const Battle = makeShortcode("Battle");
const layoutProps = {
  _frontmatter
};

const MDXLayout = ({
  children
}) => <Layout>{children}</Layout>;

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Ochette Single Story" mdxType="SEO" />
    <p>{`Route is largely based on `}<a parentName="p" {...{
        "href": "https://drive.google.com/file/d/1aOEp6pfOeCLe7CkKNNZPuweGNtElooZw/"
      }}>{`Altabiscuits's notes`}</a>{` and Tachibana's route.`}</p>
    <h2 {...{
      "id": "route"
    }}>{`Route`}</h2>
    <p>{`Start Ochette`}<br parentName="p"></br>{`
`}{`Choose Akala.`}</p>
    <p>{`King Iguana: Precise Shot, Akala x3, Capture`}<br parentName="p"></br>{`
`}{`Provoke: Akala, Akala, Akala x2. Watch for Grape drop.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "monster"
      }}>{`Monster`}</h5>
      <ul>
        <li parentName="ul">{`Disable Auto Capture`}</li>
        <li parentName="ul">{`Prepare King Iguana`}</li>
      </ul>
    </Menu>
    <p>{`Go to Trade Shop`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "trade"
      }}>{`Trade`}</h5>
      <ul>
        <li parentName="ul">{`Traveler's Bow, equip to Ochette`}</li>
      </ul>
    </Menu>
    <p>{`Can break Path battle with Axe. Recommend break`}<br parentName="p"></br>{`
`}{`Can break Tomb battle with Precise Shot x2. Recommend Flee`}</p>
    <p>{`Forced battle: Bow x2.`}</p>
    <p>{`There is a chance you get a battle on both these walks. Recommend walking half of first part, and running 2nd part.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "dark-entity-2500hp-4s-daggeraxethunderwind"
      }}>{`Dark Entity 2500HP 4S (Dagger,Axe,Thunder,Wind)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`Count crit bonus damage first 5 turns, might need to do variation based off damage. For counting, +10 for Attack hits and +30 for Precise Shot crits.`}</p>
      </blockquote>
      <ol>
        <li parentName="ol">{`Ochette: Axe`}</li>
        <li parentName="ol">{`Ochette: Axe`}</li>
        <li parentName="ol">{`Ochette: Axe`}</li>
        <li parentName="ol">{`Ochette: Axe`}</li>
        <li parentName="ol">{`Ochette: Precise Shot x3`}</li>
        <li parentName="ol">{`Ochette: Healing Grape / Jerky if no drop on Provoke`}</li>
      </ol>
      <blockquote>
        <p parentName="blockquote">{`If damage > +35, Defend and Axe x4 next turn, then Precise Shot x3. You can ignore this if you get Ochette 2nd this turn and 1st next turn. To be safe, might want to make the threshold -25 damage to cover an attack crit. You will probably want to replace the 1st 2 attacks in next phase with Thunderbird as well.`}</p>
      </blockquote>
      <ol {...{
        "start": 7
      }}>
        <li parentName="ol">{`Ochette: Axe`}</li>
        <li parentName="ol">{`Ochette: Axe x3`}</li>
        <li parentName="ol">{`Ochette: Precise Shot x4`}</li>
      </ol>
      <blockquote>
        <p parentName="blockquote">{`If you had to do backup and got no bonus damage, you are roughly -70, and need 2 Thunderbirds (1 if you are -45)`}</p>
      </blockquote>
      <ol {...{
        "start": 10
      }}>
        <li parentName="ol">{`Ochette: Axe `}<strong parentName="li">{`Dark Entity`}</strong></li>
        <li parentName="ol">{`Ochette: Axe`}</li>
      </ol>
      <blockquote>
        <p parentName="blockquote">{`This can be moved to whenever it's needed.`}</p>
      </blockquote>
      <ol {...{
        "start": 12
      }}>
        <li parentName="ol">{`Ochette: Healing Grape`}</li>
        <li parentName="ol">{`Ochette: Axe`}</li>
      </ol>
      <blockquote>
        <p parentName="blockquote">{`If +105, can do Axe x2 into Beastly Claws x4`}<br parentName="p"></br>{`
`}{`Should be able to Akala unless you were negative damage (Precise Shot x3 variation)`}</p>
      </blockquote>
      <ol {...{
        "start": 14
      }}>
        <li parentName="ol">{`Ochette: Axe`}</li>
        <li parentName="ol">{`Ochette: `}{`[LP]`}{` Beastly Claws`}</li>
        <li parentName="ol">{`Ochette: Precise Shot x3 / Akala x3 if enough damage`}</li>
      </ol>
    </Battle>
    <blockquote>
      <p parentName="blockquote">{`I recommend breaking battles you can break with Attacks on this trip.`}</p>
    </blockquote>
    <p>{`Go to `}<strong parentName="p">{`Beasting Bay: Anchorage`}</strong>{`. Exit screen and warp back.`}<br parentName="p"></br>{`
`}{`Take boat to `}<strong parentName="p">{`New Delsta Anchorage`}</strong>{`.`}</p>
    <p>{`Pick `}<strong parentName="p">{`Slumber Sage`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Tag `}<strong parentName="p">{`Abandoned Village`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Tag `}<strong parentName="p">{`New Delsta`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Abandoned Village`}</strong>{`, go get `}<strong parentName="p">{`Osvald`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Beasting Bay: Anchorage`}</strong>{`. Take boat to `}<strong parentName="p">{`Canalbrine`}</strong>{`.`}</p>
    <h3 {...{
      "id": "canalbrine"
    }}>{`Canalbrine`}</h3>
    <p>{`Get `}<strong parentName="p">{`Castti`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Buy `}<strong parentName="p">{`Critical Earring`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`New Delsta`}</strong>{`.`}</p>
    <h3 {...{
      "id": "new-delsta"
    }}>{`New Delsta`}</h3>
    <p>{`Start `}<strong parentName="p">{`Throne`}</strong>{` recruitment.`}</p>
    <Battle mdxType="Battle">
      <blockquote>
        <p parentName="blockquote">{`Ochette can miss with both Beastly Claws and Precise Shot. Backup as needed.`}<br parentName="p"></br>{`
`}{`Note if you got Untouched bonus.`}</p>
      </blockquote>
      <h4 {...{
        "id": "ochette-lp"
      }}>{`Ochette LP`}</h4>
      <ul>
        <li parentName="ul">{`Ochette: `}{`[LP]`}{` Beastly Claws x2`}</li>
        <li parentName="ul">{`Castti or Osvald: Attack x2 bottom one`}</li>
      </ul>
      <h4 {...{
        "id": "no-ochette-lp"
      }}>{`No Ochette LP`}</h4>
      <ul>
        <li parentName="ul">{`Ochette: Precise Shot x2 (2 top 1 bottom)`}</li>
        <li parentName="ul">{`Osvald: Icewind x2`}</li>
        <li parentName="ul">{`Castti: Attack x2 bottom one / Icicle x2 if first`}</li>
      </ul>
    </Battle>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "items"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`Unequip Traveler's Bow`}</li>
      </ul>
    </Menu>
    <p>{`Steal `}<strong parentName="p">{`Ice S, Wind S, Light S`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to `}<strong parentName="p">{`Weapon Shop`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`3 Unerring Earring (Equip 2 to Throne)`}</li>
      </ul>
    </Menu>
    <p>{`Steal `}<strong parentName="p">{`Antique Coin`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Soothe `}<strong parentName="p">{`Aggravated Woman`}</strong>{` to complete `}<strong parentName="p">{`Utterly Exhausted!`}</strong>{` quest.`}<br parentName="p"></br>{`
`}{`Steal `}<strong parentName="p">{`Rare Cog`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Abandoned Village`}</strong>{`.`}</p>
    <h3 {...{
      "id": "abandoned-village"
    }}>{`Abandoned Village`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Herb of Serenity`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "sell"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Antique Coin`}</li>
        <li parentName="ul">{`Rare Cog`}</li>
        <li parentName="ul">{`Traveler's Bow`}</li>
        <li parentName="ul">{`Dragon Scarf`}</li>
        <li parentName="ul"><em parentName="li">{`3 Plums if no Untouched Bonus on Throne Recruitment`}</em></li>
      </ul>
      <h5 {...{
        "id": "buy-1"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`1 Fire S`}</li>
        <li parentName="ul">{`1 Ice S`}</li>
        <li parentName="ul">{`1 Thunder S`}</li>
        <li parentName="ul">{`3 Fire M`}</li>
        <li parentName="ul">{`6 Light M`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`You have 3 small stones, 1 Ice S, 1 Wind S, 1 Light S. They should be used to clear small battles on the way to Conning Creek. If you get a Cait/Puff or Sailfish and want to fast kill, you can use a Light M and used the saved S Stone for the C2S Provoke.`}</p>
      </blockquote>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Canalbrine`}</strong>{`, head to `}<strong parentName="p">{`Conning Creek`}</strong>{`.`}</p>
    <p>{`Kill 3 Canalbrine battles using 3 S Stones.`}<br parentName="p"></br>{`
`}{`If you find a Cait/Puff, kill with Light M, and break and flee from 1 of the Crackridge battles.`}</p>
    <p>{`Kill both Conning battles with Fire M. After the 1st one, menu.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "skills"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Ochette: +Leghold +Abating Orb`}</li>
        <li parentName="ul">{`Osvald: +Lightning Bolt +Analyze`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Ochette: +`}{`[2]`}{`Heightened Senses`}</li>
        <li parentName="ul">{`Osvald: +`}{`[2]`}{`Evasive Maneuvers`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "conning-creek"
    }}>{`Conning Creek`}</h3>
    <p>{`Start Ochette Ch.2`}<br parentName="p"></br>{`
`}{`Steal `}<strong parentName="p">{`Wind L`}</strong>{` and optionally `}<strong parentName="p">{`Pom M`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If you get a Pom anywhere, you can Attack x2 Glacis and Pom Throne.`}</p>
    </blockquote>
    <p>{`Pick `}<strong parentName="p">{`Rainbow Glass Bottle`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Provoke Alpione, Light M.`}</p>
    <h4 {...{
      "id": "cavern-of-the-sea-god"
    }}>{`Cavern of the Sea God`}</h4>
    <p>{`Kill battle with Fire M, pick `}<strong parentName="p">{`$6000`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Finish chapter.`}</p>
    <p>{`TP `}<strong parentName="p">{`New Delsta Anchorage`}</strong>{`.`}</p>
    <h3 {...{
      "id": "new-delsta-anchorage"
    }}>{`New Delsta Anchorage`}</h3>
    <p>{`Go to Inventor, do Inventor stuff`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equip-skills-1"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`All: +`}{`[1]`}{`A Step Ahead`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`New Delsta: Anchorage`}</strong>{`. Take boat to `}<strong parentName="p">{`Crackridge Harbor: Anchorage`}</strong>{`.`}</p>
    <h3 {...{
      "id": "crackridge-harbor-anchorage"
    }}>{`Crackridge Harbor: Anchorage`}</h3>
    <p>{`Run from battle.`}</p>
    <h4 {...{
      "id": "southern-crackridge-wilds"
    }}>{`Southern Crackridge Wilds`}</h4>
    <p>{`Break Armor Eater and kill with Light M.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$6400`}</strong>{`.`}</p>
    <h4 {...{
      "id": "western-crackridge-wilds"
    }}>{`Western Crackridge Wilds`}</h4>
    <p>{`Break Armor Eater and kill with Light M. If you used an extra earlier, just break and flee.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$8400`}</strong>{`. Pick `}<strong parentName="p">{`Thunder M`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Get `}<strong parentName="p">{`Merchant License`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`If low on JP, can delay HP Thief. Will need to get it in Stormhail or something.`}</p>
      </blockquote>
      <h5 {...{
        "id": "jobs"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Throne: +HP Thief +Armor Corrosive, Merchant, +Donate BP +Hired Help`}</li>
        <li parentName="ul">{`Castti: Inventor`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-2"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Throne: +`}{`[2]`}{`Grow on Trees`}</li>
      </ul>
    </Menu>
    <p>{`Switch to night, start looking for Meep. Break and flee from any battle that isn't a Meep.`}</p>
    <ul>
      <li parentName="ul">{`Wild Mole V x2: Break with Sword/Bow/Staff. Easiest is HHM x3`}</li>
      <li parentName="ul">{`Two-Handed Hatchling, Wild Mole V: Sword/Axe, Sword/Bow/Staff. Easiest is again HHM x3`}</li>
      <li parentName="ul">{`Armor Eater, Buttermeep, Two-Handed Hatchling: Break Armor Eater, Light M, capture Buttermeep`}</li>
      <li parentName="ul">{`Buttermeep x2, Tempest Falcon x2: Break 1 Meep (Sword/Bow), then Light M and Capture the other.`}</li>
      <li parentName="ul">{`Two-Handed Hatchling x3: Sword/Axe/Fire`}</li>
      <li parentName="ul">{`Wild Mole IV x2, Armor Eater: You should already know.`}</li>
    </ul>
    <p>{`Turn Meep into food, enter `}<strong parentName="p">{`Crackridge`}</strong>{`.`}</p>
    <h3 {...{
      "id": "crackridge"
    }}>{`Crackridge`}</h3>
    <p>{`Befriend.`}</p>
    <h4 {...{
      "id": "path-to-bed-of-the-titan"
    }}>{`Path to Bed of the Titan`}</h4>
    <p>{`Kill battle with HHG x2.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Knight's Greatbow`}</strong>{`.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "tera-43500hp-6s-daggeraxestafficedark"
      }}>{`Tera 43500HP 6S (Dagger,Axe,Staff,Ice,Dark)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`Fight can also be done with 2M stones, if you used your Wind L in Crackridge`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Ochette: Defend`}</li>
        <li parentName="ul">{`Osvald: Attack x2`}</li>
        <li parentName="ul">{`Castti: Crit Scope`}</li>
        <li parentName="ul">{`Throne: Attack`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Ochette: Axe x3`}</li>
        <li parentName="ul">{`Osvald: Wind L`}</li>
        <li parentName="ul">{`Castti: Spring Boots Throne if she's after Ochette`}</li>
        <li parentName="ul">{`Throne: Armor Corrosive`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Throne: HHB x4`}</li>
        <li parentName="ul">{`Ochette: Capture`}</li>
      </ul>
      <h4 {...{
        "id": "with-ochette--throne-boost-start"
      }}>{`With Ochette & Throne Boost Start`}</h4>
      <h5 {...{
        "id": "turn-1-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Ochette: Axe x3`}</li>
        <li parentName="ul">{`Osvald: Defend`}</li>
        <li parentName="ul">{`Castti: Crit Scope`}</li>
        <li parentName="ul">{`Throne: Armor Corrosive`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-1"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Attack x3 `}</li>
        <li parentName="ul">{`Ochette: Capture / Defend`}</li>
        <li parentName="ul">{`Castti: Wind L`}</li>
        <li parentName="ul">{`Throne: HHB x4`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`New Delsta`}</strong>{`, head to `}<strong parentName="p">{`Stormhail`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-1"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Ochette: Merchant, +3 Skills`}</li>
        <li parentName="ul">{`Castti: Merchant, +3 Skills, `}<strong parentName="li">{`Inventor`}</strong></li>
        <li parentName="ul">{`Throne: Merchant, +Collect`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-3"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Ochette: +`}{`[4]`}{`Grow on Trees +`}{`[3]`}{`Boost Start`}</li>
        <li parentName="ul">{`Throne: +`}{`[3]`}{`Boost Start`}</li>
        <li parentName="ul">{`Castti: +`}{`[4]`}{`Boost Start -`}{`[1]`}{`A Step Ahead`}</li>
        <li parentName="ul">{`Osvald: -`}{`[1]`}{`A Step Ahead`}</li>
      </ul>
    </Menu>
    <blockquote>
      <h3 parentName="blockquote" {...{
        "id": "money-route"
      }}>{`Money Route`}</h3>
      <p parentName="blockquote">{`Assuming you take all lowest income battles, you end up with an "extra" $9600.`}<br parentName="p"></br>{`
`}{`You can then do HHB for the 3rd Ch3 fight, and you have $1600 left. You can also`}<br parentName="p"></br>{`
`}{`use that money to HHG a battle before Ch3 incase you get ambushed, which leaves you`}<br parentName="p"></br>{`
`}{`with $2600 extra. These numbers assume you don't use HHG on the 1st Ch3 battle.`}<br parentName="p"></br>{`
`}{`Since you have a bit of extra money, you can afford to flee from 1/2 battles on this trip.`}<br parentName="p"></br>{`
`}{`Note that you might need to use money for HHR.`}</p>
    </blockquote>
    <p>{`Run from small battles, kill Borderfall/Montwise with Tera. If Throne is 2nd T1, can try to flee.`}<br parentName="p"></br>{`
`}{`Soothe Guard.`}</p>
    <h4 {...{
      "id": "northern-montwise-pass"
    }}>{`Northern Montwise Pass`}</h4>
    <p>{`I recommend taking the night battles, that way only 1 battle requires HHR and night battles generally die a bit faster.`}</p>
    <h5 {...{
      "id": "universal"
    }}>{`Universal`}</h5>
    <ul>
      <li parentName="ul">{`Mountain Apeking II, Mountain Apeking I: HHR x2, Tera`}</li>
      <li parentName="ul">{`Mountain Ape VI x2, Mountain Apeking II: Armor Corrosive Apeking, Tera`}</li>
      <li parentName="ul">{`Horned Fly x2, Mountain Goat: Tera`}</li>
      <li parentName="ul">{`Mountain Goat x2, Mountain Ape VI: Tera`}</li>
    </ul>
    <h5 {...{
      "id": "day"
    }}>{`Day`}</h5>
    <ul>
      <li parentName="ul">{`Wild Weasel x2, Dark Spiny Shrew: Spear x3 Shrew, Tera`}</li>
      <li parentName="ul">{`Dark Spiny Shrew x4: HHR x2, Tera`}</li>
    </ul>
    <h5 {...{
      "id": "night"
    }}>{`Night`}</h5>
    <ul>
      <li parentName="ul">{`Winged Serpent, Wild Weasel: Tera`}</li>
      <li parentName="ul">{`Winged Serpent x2: Tera`}</li>
    </ul>
    <h4 {...{
      "id": "southern-stormhail-snows"
    }}>{`Southern Stormhail Snows`}</h4>
    <ul>
      <li parentName="ul">{`Frost Moleking II, Frost Moleking I: Tera`}</li>
      <li parentName="ul">{`Frost Mole VI x2, Frost Moleking II: Tera`}</li>
      <li parentName="ul">{`Plains Drake x2, Frostwing Serpent: Break Serpent with Spear x3, Tera`}</li>
      <li parentName="ul">{`Frost Moleking I x2, Plains Drake: HHR x2 or Bow x3 Drake (can miss) or Attack x4 Moleking (Turn order dependant). T2 Tera`}</li>
      <li parentName="ul">{`Albino Bat x4: Tera`}</li>
      <li parentName="ul">{`Reptalios x2: HHR x2 + Tera or HHM x4 + Tera or HHM x4 into flee`}</li>
      <li parentName="ul">{`Reptalios, Frostwing Serpent: Throne Spear x3 Frostwing Serpant, Tera`}</li>
    </ul>
    <h3 {...{
      "id": "stormhail"
    }}>{`Stormhail`}</h3>
    <p>{`If you used an extra M Stone, can Steal Shadow M (55%) or pick Ice L in Sacred Peak Altahe. You want to try to keep 1 Light M for Ch3 1st battle.`}<br parentName="p"></br>{`
`}{`Go to Weapon Shop, Mug guy for weapons (`}<strong parentName="p">{`Thunder`}</strong>{` M Stone).`}<br parentName="p"></br>{`
`}{`Talk to shop keeper`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "sell-1"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Ogre's Bane`}</li>
        <li parentName="ul">{`Imperial Axe`}</li>
        <li parentName="ul">{`Guardian's Great Axe`}</li>
        <li parentName="ul">{`Knight's Greatbow`}</li>
        <li parentName="ul">{`Thunderstorm Amulet`}</li>
      </ul>
    </Menu>
    <p>{`Provoke: M/S Stone, Tera`}</p>
    <h4 {...{
      "id": "sacred-peak-altahe"
    }}>{`Sacred Peak Altahe`}</h4>
    <p>{`Walk till 1st cutscene. Pick `}<strong parentName="p">{`Reinforcing Jam`}</strong>{` in the 1st chest.`}<br parentName="p"></br>{`
`}{`If needed, pick `}<strong parentName="p">{`Ice L`}</strong>{` after 1st cutscene.`}</p>
    <ul>
      <li parentName="ul">{`Avalanche Mushroom x2: Tera, or both Attack x3 to break and flee`}</li>
      <li parentName="ul">{`Albino Bat x4: Tera`}</li>
      <li parentName="ul">{`Albino Bat x2, Frostwing Serpent: Tera`}</li>
      <li parentName="ul">{`Winter Wanderweed x2, Avalanche Mushroom: Throne Attack x3, Tera`}</li>
      <li parentName="ul">{`Winter Wanderweed x2, Frost Moleking II: Throne Attack x3, Tera`}</li>
      <li parentName="ul">{`Reptalios x2: HHR x2 + Tera or HHM x4 + Tera or HHM x4 into flee`}</li>
      <li parentName="ul">{`Reptalios, Frostwing Serpent: Throne Spear x3 Frostwing Serpant, Tera`}</li>
    </ul>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equip-skills-4"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: +`}{`[1]`}{`A Step Ahead`}</li>
        <li parentName="ul">{`Castti: +`}{`[1]`}{`A Step Ahead`}</li>
      </ul>
    </Menu>
    <blockquote>
      <p parentName="blockquote">{`For HHB 3rd Ch3 battle, need >= $55380 when using HHB`}<br parentName="p"></br>{`
`}{`For HHG 1st Ch3 battle, need >= $54380 when using HHB`}</p>
    </blockquote>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "glacis-54000hp-8s-speardaggerbowfire"
      }}>{`Glacis 54000HP 8S (Spear,Dagger,Bow,Fire)`}</h4>
      <h5 {...{
        "id": "turn-1-2"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Ochette: (LATENT) Beastly Howl / Precise Shot (if no latent)`}</li>
        <li parentName="ul">{`Osvald: Fireball`}</li>
        <li parentName="ul">{`Throne: HP Thief`}</li>
        <li parentName="ul">{`Castti: Springy Boots Self`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Castti: Elemental Bomb Bottle x4`}</li>
        <li parentName="ul">{`Ochette: Tera (use T3 if latent not used)`}</li>
        <li parentName="ul">{`Throne: Armor Corrosive (if Ochette latent not used)`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-1"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Castti: Critical Scope`}</li>
        <li parentName="ul">{`Ochette: Capture / Defend`}</li>
        <li parentName="ul">{`Throne: HHB x4`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Beasting Village`}</strong>{`.`}</p>
    <h3 {...{
      "id": "beasting-village"
    }}>{`Beasting Village`}</h3>
    <h4 {...{
      "id": "battles"
    }}>{`Battles`}</h4>
    <ol>
      <li parentName="ol">{`Light M + Glacis or HHGx3 + Tera`}</li>
      <li parentName="ol">{`HHG x4, if Throne needs LP use Osvald Staff and/or Castti Staff Catapult to knock off shields`}</li>
    </ol>
    <blockquote>
      <p parentName="blockquote">{`For HHB B3, need $63370 when doing HHG on B2`}</p>
    </blockquote>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`HHG x3 + Tera or HHB x3`}</li>
    </ol>
    <p>{`If Throne no LP, on 2nd screen pick `}<strong parentName="p">{`Lychee L`}</strong>{`. Use Travel Banter to reset steps.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "malamaowl-of-the-sorrowful-moon-96000hp-7s-daggerbowfire"
      }}>{`Malamaowl of the Sorrowful Moon 96000HP 7S (Dagger,Bow,Fire)`}</h4>
      <h5 {...{
        "id": "turn-1-3"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Fireball`}</li>
        <li parentName="ul">{`Castti: Springy Boots Self`}</li>
        <li parentName="ul">{`Throne: HP Thief`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-3"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Castti: Elemental Bomb Bottle x4`}</li>
        <li parentName="ul">{`Ochette: Abating Orb`}</li>
        <li parentName="ul">{`Throne: `}{`[LP]`}{` Armor Corrosive, HHB x4`}</li>
        <li parentName="ul">{`Osvald: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-2"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Reinforcing Jam Throne`}</li>
        <li parentName="ul">{`Castti: Critical Scope`}</li>
        <li parentName="ul">{`Throne: `}{`[LP]`}{`HHB x4, HHB x3`}</li>
        <li parentName="ul">{`Ochette: M Stone`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "changelog"
    }}>{`Changelog`}</h3>
    <h4 {...{
      "id": "32624"
    }}>{`3/26/24`}</h4>
    <ul>
      <li parentName="ul">{`Changed Stone Count to buy 2 less S, 1 more M.`}</li>
      <li parentName="ul">{`Wrote out more details`}</li>
    </ul>
    <h4 {...{
      "id": "31324"
    }}>{`3/13/24`}</h4>
    <ul>
      <li parentName="ul">{`Initial upload`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      